import styled from 'styled-components'

import theme from '../../theme'

const StyledTable = styled.table`
  border-collapse: separate;
  border-spacing: 0px 3px;
`

const StyledHeader = styled.thead`
  height: 80px;
  background-color: ${theme.colors.lightBackground};
`

const StyledHeaderCell = styled.th`
  padding: 16px 24px;
`

const StyledRow = styled.tr`
  height: 112px;
  background-color: ${theme.colors.white};
  color: ${theme.colors.gray10};
`

const StyledCell = styled.td`
  padding: 16px 24px;
`
export { StyledTable, StyledHeader, StyledHeaderCell, StyledRow, StyledCell }
